/**
 * @generated SignedSource<<3b4139b655ba7d1603b4afd9ba0d0cf6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoListItemFooterSubTodos_todo$data = {
  readonly id: string;
  readonly subTodos: ReadonlyArray<{
    readonly status: TodoStatus;
  }> | null;
  readonly " $fragmentType": "TodoListItemFooterSubTodos_todo";
};
export type TodoListItemFooterSubTodos_todo$key = {
  readonly " $data"?: TodoListItemFooterSubTodos_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemFooterSubTodos_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemFooterSubTodos_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Todo",
      "kind": "LinkedField",
      "name": "subTodos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "7ff5e00d0b77f1fd0abac93c5e770480";

export default node;
